// export const convertFabricCanvasToPNGDataURL = (canvasJSON) => {
//   return new Promise((resolve, reject) => {
//     if (!canvasJSON) return reject("No canvas data");

//     let cleanedJSON;
//     try {
//       const parsedJSON = typeof canvasJSON === "string" ? JSON.parse(canvasJSON) : canvasJSON;
//       cleanedJSON = {
//         ...parsedJSON,
//         objects: parsedJSON.objects?.filter(
//           (obj) => !(obj?.data?.isWatermark)
//         ),
//       };
//     } catch (err) {
//       return reject("Invalid canvas JSON");
//     }

//     const offscreenCanvas = document.createElement("canvas");
//     offscreenCanvas.width = 1000;
//     offscreenCanvas.height = 1000;
//     const staticCanvas = new fabric.StaticCanvas(offscreenCanvas, {
//       width: 1000,
//       height: 1000,
//     });

//     staticCanvas.loadFromJSON(cleanedJSON, () => {

//       const objects = staticCanvas.getObjects();
//       if (!objects.length) return reject("No objects in canvas");

//       // Calculate bounding box of all objects
//       const bounds = staticCanvas.getObjects().reduce((bounds, obj) => {
//         const objBounds = obj.getBoundingRect();
//         return {
//           left: Math.min(bounds.left, objBounds.left),
//           top: Math.min(bounds.top, objBounds.top),
//           right: Math.max(bounds.right, objBounds.left + objBounds.width),
//           bottom: Math.max(bounds.bottom, objBounds.top + objBounds.height)
//         };
//       }, { left: Infinity, top: Infinity, right: -Infinity, bottom: -Infinity });

//       // Calculate original dimensions
//       const originalWidth = bounds.right - bounds.left;
//       const originalHeight = bounds.bottom - bounds.top;
//       const aspectRatio = originalWidth / originalHeight;

//       // Calculate new dimensions maintaining aspect ratio with max 1000px
//       let newWidth, newHeight;
//       if (aspectRatio >= 1) {
//         // Wider than tall
//         newWidth = 1000;
//         newHeight = 1000 / aspectRatio;
//       } else {
//         // Taller than wide
//         newHeight = 1000;
//         newWidth = 1000 * aspectRatio;
//       }

//       // Create a new canvas for the final scaled version
//       const finalCanvas = document.createElement("canvas");
//       finalCanvas.width = newWidth;
//       finalCanvas.height = newHeight;

//       const finalStaticCanvas = new fabric.StaticCanvas(finalCanvas, {
//         width: newWidth,
//         height: newHeight
//       });


//       // Clone all objects to the new canvas
//       const clonedObjects = objects.map(obj => fabric.util.object.clone(obj));

//       // Calculate scale to fit
//       const scale = newWidth / originalWidth;

//       // Center and scale the cloned objects
//       clonedObjects.forEach(obj => {
//         obj.oldScaleX = obj.scaleX;
//         obj.scaleX = obj.scaleX * scale;
//         obj.oldScaleY = obj.scaleY;
//         obj.scaleY = obj.scaleY * scale;
//         obj.oldLeft =(obj.left);
//         obj.left = (obj.left - bounds.left) * scale;
//         obj.oldTop =(obj.top ) ;
//         obj.top = (obj.top - bounds.top) * scale;
//         obj.setCoords();
//         console.log(obj.left, obj.top);
//         console.log(obj.oldLeft, obj.oldTop);
//         finalStaticCanvas.add(obj);
//       });

//       finalStaticCanvas.renderAll();

//       const originalBackgroundColor = finalStaticCanvas.backgroundColor;
//       staticCanvas.backgroundColor = "transparent";
//       const pngDataURL = finalStaticCanvas.toDataURL({
//         format: "png",
//         multiplier: 1,
//         width: newWidth,
//         height: newHeight,
//         transparent: true,
//       });
//       finalStaticCanvas.backgroundColor = originalBackgroundColor;
// // Calculate scaled size for reference
//       const scaledSize = {
//         width: newWidth,
//         height: newHeight
//       };

//       // Center and scale the cloned objects
//       clonedObjects.forEach(obj => {
//         obj.scaleX = obj.oldScaleX;
//         obj.scaleY = obj.oldScaleY;
//         obj.left = (obj.oldLeft);
//         obj.top = (obj.oldTop);
//         obj.setCoords();
//         //finalStaticCanvas.add(obj);
//       });

//       finalStaticCanvas.renderAll();

//       finalStaticCanvas.remove();

//       resolve({
//         dataUrl: pngDataURL,
//         originalSize: {
//           width: originalWidth,
//           height: originalHeight
//         },
//         scaledSize: {
//           width: newWidth,
//           height: newHeight
//         }

//       });
//     });
//   });
// };

export const convertFabricCanvasToPNGDataURL = async (canvasJSON) => {
  if (!canvasJSON) throw new Error("No canvas data");

  let cleanedJSON;
  try {
    const parsedJSON = typeof canvasJSON === "string" ? JSON.parse(canvasJSON) : canvasJSON;
    cleanedJSON = {
      ...parsedJSON,
      objects: parsedJSON.objects?.filter(
        (obj) => !(obj?.data?.isWatermark)
      ),
    };
  } catch (err) {
    throw new Error("Invalid canvas JSON");
  }

  const offscreenCanvas = document.createElement("canvas");
  offscreenCanvas.width = 1000;
  offscreenCanvas.height = 1000;
  const staticCanvas = new fabric.StaticCanvas(offscreenCanvas, {
    width: 1000,
    height: 1000,
  });

 
  await new Promise((resolve) => {
    staticCanvas.loadFromJSON(cleanedJSON, resolve);
  }); 

  const objects = staticCanvas.getObjects();
  if (!objects.length) throw new Error("No objects in canvas");

  const bounds = objects.reduce((bounds, obj) => {
    const objBounds = obj.getBoundingRect();
    return {
      left: Math.min(bounds.left, objBounds.left),
      top: Math.min(bounds.top, objBounds.top),
      right: Math.max(bounds.right, objBounds.left + objBounds.width),
      bottom: Math.max(bounds.bottom, objBounds.top + objBounds.height)
    };
  }, { left: Infinity, top: Infinity, right: -Infinity, bottom: -Infinity });

  const originalWidth = bounds.right - bounds.left;
  const originalHeight = bounds.bottom - bounds.top;
  const aspectRatio = originalWidth / originalHeight;

  let newWidth, newHeight;
  if (aspectRatio >= 1) {
    newWidth = 1000;
    newHeight = 1000 / aspectRatio;
  } else {
    newHeight = 1000;
    newWidth = 1000 * aspectRatio;
  }

  const finalCanvas = document.createElement("canvas");
  finalCanvas.width = newWidth;
  finalCanvas.height = newHeight;

  const finalStaticCanvas = new fabric.StaticCanvas(finalCanvas, {
    width: newWidth,
    height: newHeight,
  });

 
  const clonedObjects = await Promise.all(
    objects.map(obj => new Promise((resolve) => {
      obj.clone(cloned => resolve(cloned));
    }))
  );

  const scale = newWidth / originalWidth;

  clonedObjects.forEach(obj => {
    obj.oldScaleX = obj.scaleX;
    obj.scaleX *= scale;
    obj.oldScaleY = obj.scaleY;
    obj.scaleY *= scale;
    obj.oldLeft = obj.left;
    obj.left = (obj.left - bounds.left) * scale;
    obj.oldTop = obj.top;
    obj.top = (obj.top - bounds.top) * scale;
    obj.setCoords();
    finalStaticCanvas.add(obj);
  });

  finalStaticCanvas.renderAll();

  const pngDataURL = finalStaticCanvas.toDataURL({
    format: "png",
    multiplier: 1,
    width: newWidth,
    height: newHeight,
    transparent: true,
  });

  return {
    dataUrl: pngDataURL,
    originalSize: {
      width: originalWidth,
      height: originalHeight,
    },
    scaledSize: {
      width: newWidth,
      height: newHeight,
    },
  };
};

export async function handleDownloadSVG(canvas) {
  if (!canvas) return;

  const originalBackgroundColor = canvas.backgroundColor;
  canvas.backgroundColor = null;


  await document.fonts.ready;
  const svgDataURL = canvas.toSVG();

  canvas.backgroundColor = originalBackgroundColor;

  const svgBlob = new Blob([svgDataURL], { type: "image/svg+xml" });

  const svgURL = URL.createObjectURL(svgBlob);

  return svgURL;
};

/**
 * Converts an SVG URL to a PNG data URL using an offscreen canvas.
 * @param {string} svgUrl - The URL of the SVG image.
 * @returns {Promise<string>} - A promise that resolves with the PNG data URL.
 */
export const convertSVGToPNGDataURL = (svgUrl) => {
  return new Promise((resolve, reject) => {
    if (!svgUrl) return reject("No SVG URL provided");

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      // Determine screen width
      const screenWidth =
        window.innerWidth || document.documentElement.clientWidth;
      const canvasSize = 500;

      const canvas = document.createElement("canvas");
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const ctx = canvas.getContext("2d");
      // Disable image smoothing for crisp pixels
      ctx.imageSmoothingEnabled = false;

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      console.log(img.width, img.height);
      const pngDataURL = canvas.toDataURL("image/png");
      resolve(pngDataURL);
    };
    img.onerror = (err) => reject(err);
    img.src = svgUrl;
  });
};

export const handleDownload = async (
  downloadName,
  fabricCanvas,
  canvasesState,
  afterDownloadCallback
) => {
  let url = "";
  const name = downloadName === "editSVG" ? "canvas.svg" : "canvas.png";

  const savedState = canvasesState[`${downloadName}CanvasState`]?.currentState;

  if (!savedState) {
    if (!fabricCanvas) {
      return;
    }
    console.warn(
      `No saved state for "${downloadName}" found. Using the current canvas instead.`
    );
    url =
      downloadName === "editSVG"
        ? await handleDownloadSVG(fabricCanvas)
        : fabricCanvas?.lowerCanvasEl?.toDataURL("image/png");

  } else {

    // Create a new static canvas and load from the saved state
    const staticCanvas = new fabric.StaticCanvas("c");
    url = await new Promise((resolve, reject) => {
      staticCanvas.loadFromJSON(savedState, async  () => {
        try {
          let imageToDownload;

          if (downloadName === "editSVG") {
            const availableWidth = window.innerWidth - 700;
            const availableHeight = window.innerHeight - 150;
            const baseWidth = 650;
            const baseHeight = 500;
            const scaleX = availableWidth / baseWidth;
            const scaleY = availableHeight / baseHeight;
            const scale = Math.min(scaleX, scaleY);

            staticCanvas.setDimensions({
              width: baseWidth * scale,
              height: baseHeight * scale,
            });
            staticCanvas.setZoom(1);
            staticCanvas.renderAll();

            // ✅ await handleDownloadSVG
            imageToDownload = await handleDownloadSVG(staticCanvas);
          } else {
            const zoom = fabricCanvas.getZoom() || 1;
            const vpt = fabricCanvas.viewportTransform || [1, 0, 0, 1, 0, 0];

            const offsetX = vpt[4];
            const offsetY = vpt[5];

            const canvasWidth = fabricCanvas.getWidth();
            const canvasHeight = fabricCanvas.getHeight();
               fabricCanvas.discardActiveObject()
               fabricCanvas.renderAll()

            const rawCanvas = document.createElement("canvas");
            rawCanvas.width = canvasWidth;
            rawCanvas.height = canvasHeight;

            const ctx = rawCanvas.getContext("2d");

            ctx.save();
            ctx.scale(1, 1);
            ctx.drawImage(
              fabricCanvas.lowerCanvasEl,
              0, 0,
              canvasWidth, canvasHeight,
              0, 0,
              canvasWidth, canvasHeight
            );
            ctx.restore();

            imageToDownload = rawCanvas.toDataURL("image/png");
          }
          resolve(imageToDownload);
        } catch (err) {
          reject(err);
        }
      });
    });
  }

  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  afterDownloadCallback && afterDownloadCallback();
};


export function normalizeFill(fill) {
  if (!fill) return "#ffffff";
  if (fill[0] === "#" && (fill.length === 7 || fill.length === 4)) {
    if (fill.length === 4) {
      return "#" + [...fill.slice(1)].map(c => c + c).join("");
    }
    return fill;
  }
  const m = fill.match(/rgba?\((\d+), *(\d+), *(\d+)/);
  if (m) {
    return "#" +
      [1,2,3].map(i =>
        parseInt(m[i], 10)
          .toString(16)
          .padStart(2, "0")
      ).join("");
  }

  if (fabric && fabric.Color) {
    try {
      return "#" + new fabric.Color(fill).toHex();
    } catch {}
  }

  return "#000000";
}